/** Select vehicle type**/
  function showEngineType(select) {
    if (select.value == "Diesel") {
      document.getElementById('DieselFormEngineType').style.display = "block";
      document.getElementById('GasFormEngineType').style.display = "none";

      document.getElementById('GasV6').style.display = "none";
      document.getElementById('GasI6').style.display = "none";
      document.getElementById('GasV8').style.display = "none";
      document.getElementById('GasI4').style.display = "none";

      document.getElementById('dieselEngineType').selectedIndex = 0;

    } else {
      document.getElementById('DieselFormEngineType').style.display = "none";
      document.getElementById('GasFormEngineType').style.display = "block";

      document.getElementById('DieselV6').style.display = "none";
      document.getElementById('DieselI6').style.display = "none";
      document.getElementById('DieselV8').style.display = "none";
      document.getElementById('DieselI4').style.display = "none";

      document.getElementById('gasEngineType').selectedIndex = 0;

    }

    uncheckBox();
  }


  /** Select Engine Type **/
  function showDieselServices(select) {

    if (select.value == "Diesel V6") {
      document.getElementById('DieselV6').style.display = "block";
      document.getElementById('DieselI6').style.display = "none";
      document.getElementById('DieselV8').style.display = "none";
      document.getElementById('DieselI4').style.display = "none";

      var inputCheckboxV6 = document.querySelectorAll("input#header-V6");
      for (var i = 0; i < inputCheckboxV6.length; i++) {
        inputCheckboxV6[i].checked = true;
      }

      var inputCheckboxV8 = document.querySelectorAll("input#header-V8");
      for (var i = 0; i < inputCheckboxV8.length; i++) {
        inputCheckboxV8[i].checked = false;
      }

      var inputCheckboxI4 = document.querySelectorAll("input#header-I4");
      for (var i = 0; i < inputCheckboxI4.length; i++) {
        inputCheckboxI4[i].checked = false;
      }

      var inputCheckboxI6 = document.querySelectorAll("input#header-I6");
      for (var i = 0; i < inputCheckboxI6.length; i++) {
        inputCheckboxI6[i].checked = false;
      }

    } else if (select.value == "Diesel V8") {
      document.getElementById('DieselV8').style.display = "block";
      document.getElementById('DieselI6').style.display = "none";
      document.getElementById('DieselV6').style.display = "none";
      document.getElementById('DieselI4').style.display = "none";

      var inputCheckboxV6 = document.querySelectorAll("input#header-V6");
      for (var i = 0; i < inputCheckboxV6.length; i++) {
        inputCheckboxV6[i].checked = false;
      }

      var inputCheckboxV8 = document.querySelectorAll("input#header-V8");
      for (var i = 0; i < inputCheckboxV8.length; i++) {
        inputCheckboxV8[i].checked = true;
      }

      var inputCheckboxI4 = document.querySelectorAll("input#header-I4");
      for (var i = 0; i < inputCheckboxI4.length; i++) {
        inputCheckboxI4[i].checked = false;
      }

      var inputCheckboxI6 = document.querySelectorAll("input#header-I6");
      for (var i = 0; i < inputCheckboxI6.length; i++) {
        inputCheckboxI6[i].checked = false;
      }

    } else if (select.value == "Diesel I4") {
      document.getElementById('DieselI4').style.display = "block";
      document.getElementById('DieselI6').style.display = "none";
      document.getElementById('DieselV8').style.display = "none";
      document.getElementById('DieselV6').style.display = "none";

      var inputCheckboxV6 = document.querySelectorAll("input#header-V6");
      for (var i = 0; i < inputCheckboxV6.length; i++) {
        inputCheckboxV6[i].checked = false;
      }

      var inputCheckboxV8 = document.querySelectorAll("input#header-V8");
      for (var i = 0; i < inputCheckboxV8.length; i++) {
        inputCheckboxV8[i].checked = false;
      }

      var inputCheckboxI4 = document.querySelectorAll("input#header-I4");
      for (var i = 0; i < inputCheckboxI4.length; i++) {
        inputCheckboxI4[i].checked = true;
      }

      var inputCheckboxI6 = document.querySelectorAll("input#header-I6");
      for (var i = 0; i < inputCheckboxI6.length; i++) {
        inputCheckboxI6[i].checked = false;
      }

    } else if (select.value == "Diesel I6") {

      document.getElementById('DieselI6').style.display = "block";
      document.getElementById('DieselI4').style.display = "none";
      document.getElementById('DieselV8').style.display = "none";
      document.getElementById('DieselV6').style.display = "none";


      var inputCheckboxV6 = document.querySelectorAll("input#header-V6");
      for (var i = 0; i < inputCheckboxV6.length; i++) {
        inputCheckboxV6[i].checked = false;
      }

      var inputCheckboxV8 = document.querySelectorAll("input#header-V8");
      for (var i = 0; i < inputCheckboxV8.length; i++) {
        inputCheckboxV8[i].checked = false;
      }

      var inputCheckboxI4 = document.querySelectorAll("input#header-I4");
      for (var i = 0; i < inputCheckboxI4.length; i++) {
        inputCheckboxI4[i].checked = false;
      }

      var inputCheckboxI6 = document.querySelectorAll("input#header-I6");
      for (var i = 0; i < inputCheckboxI6.length; i++) {
        inputCheckboxI6[i].checked = true;
      }

    } else if (select.value == "Gas V6") {
      document.getElementById('GasV6').style.display = "block";
      document.getElementById('GasV8').style.display = "none";
      document.getElementById('GasI4').style.display = "none";
      document.getElementById('GasI6').style.display = "none";

      var inputCheckboxGasV6 = document.querySelectorAll("input#header-gas-V6");
      for (var i = 0; i < inputCheckboxGasV6.length; i++) {
        inputCheckboxGasV6[i].checked = true;
      }

      var inputCheckboxGasV8 = document.querySelectorAll("input#header-gas-V8");
      for (var i = 0; i < inputCheckboxGasV8.length; i++) {
        inputCheckboxGasV8[i].checked = false;
      }

      var inputCheckboxGasI4 = document.querySelectorAll("input#header-gas-I4");
      for (var i = 0; i < inputCheckboxGasI4.length; i++) {
        inputCheckboxGasI4[i].checked = false;
      }

      var inputCheckboxGasI6 = document.querySelectorAll("input#header-gas-I6");
      for (var i = 0; i < inputCheckboxGasI6.length; i++) {
        inputCheckboxGasI6[i].checked = false;
      }

    } else if (select.value == "Gas V8") {
      document.getElementById('GasV6').style.display = "none";
      document.getElementById('GasV8').style.display = "block";
      document.getElementById('GasI4').style.display = "none";
      document.getElementById('GasI6').style.display = "none";

      var inputCheckboxGasV6 = document.querySelectorAll("input#header-gas-V6");
      for (var i = 0; i < inputCheckboxGasV6.length; i++) {
        inputCheckboxGasV6[i].checked = false;
      }

      var inputCheckboxGasV8 = document.querySelectorAll("input#header-gas-V8");
      for (var i = 0; i < inputCheckboxGasV8.length; i++) {
        inputCheckboxGasV8[i].checked = true;
      }

      var inputCheckboxGasI4 = document.querySelectorAll("input#header-gas-I4");
      for (var i = 0; i < inputCheckboxGasI4.length; i++) {
        inputCheckboxGasI4[i].checked = false;
      }

      var inputCheckboxGasI6 = document.querySelectorAll("input#header-gas-I6");
      for (var i = 0; i < inputCheckboxGasI6.length; i++) {
        inputCheckboxGasI6[i].checked = false;
      }
    } else if (select.value == "Gas I4") {
      document.getElementById('GasV6').style.display = "none";
      document.getElementById('GasV8').style.display = "none";
      document.getElementById('GasI4').style.display = "block";
      document.getElementById('GasI6').style.display = "none";

      var inputCheckboxGasV6 = document.querySelectorAll("input#header-gas-V6");
      for (var i = 0; i < inputCheckboxGasV6.length; i++) {
        inputCheckboxGasV6[i].checked = false;
      }

      var inputCheckboxGasV8 = document.querySelectorAll("input#header-gas-V8");
      for (var i = 0; i < inputCheckboxGasV8.length; i++) {
        inputCheckboxGasV8[i].checked = false;
      }

      var inputCheckboxGasI4 = document.querySelectorAll("input#header-gas-I4");
      for (var i = 0; i < inputCheckboxGasI4.length; i++) {
        inputCheckboxGasI4[i].checked = true;
      }

      var inputCheckboxGasI6 = document.querySelectorAll("input#header-gas-I6");
      for (var i = 0; i < inputCheckboxGasI6.length; i++) {
        inputCheckboxGasI6[i].checked = false;
      }
    }else if (select.value == "Gas I6") {
      document.getElementById('GasV6').style.display = "none";
      document.getElementById('GasV8').style.display = "none";
      document.getElementById('GasI4').style.display = "none";
      document.getElementById('GasI6').style.display = "block";
      

      var inputCheckboxGasV6 = document.querySelectorAll("input#header-gas-V6");
      for (var i = 0; i < inputCheckboxGasV6.length; i++) {
        inputCheckboxGasV6[i].checked = false;
      }

      var inputCheckboxGasV8 = document.querySelectorAll("input#header-gas-V8");
      for (var i = 0; i < inputCheckboxGasV8.length; i++) {
        inputCheckboxGasV8[i].checked = false;
      }

      var inputCheckboxGasI4 = document.querySelectorAll("input#header-gas-I4");
      for (var i = 0; i < inputCheckboxGasI4.length; i++) {
        inputCheckboxGasI4[i].checked = false;
      }

      var inputCheckboxGasI6 = document.querySelectorAll("input#header-gas-I6");
      for (var i = 0; i < inputCheckboxGasI6.length; i++) {
        inputCheckboxGasI6[i].checked = true;
      }
    }


    uncheckBox();
  }

  var total_amount = 0;


  /** Uncheck All Checkbox When Swtiching Options **/
  function uncheckBox() {
    var inputCheckbox = document.querySelectorAll("input.disclamer-checkbox");
    for (var i = 0; i < inputCheckbox.length; i++) {
      inputCheckbox[i].checked = false

    }

    var inputSelect = document.querySelectorAll("select.disclamer-select");
    for (var i = 0; i < inputSelect.length; i++) {
      inputSelect[i].selectedIndex = 0;

    }

    /** Collapse Hidden Checkbox **/
    var content = document.querySelectorAll("div.div1");
    for (var i = 0; i < content.length; i++) {
      if (content[i].classList.contains("in")) {
        //content[i].classList.replace("in", "collapse");
        content[i].classList.remove("in");
      }

    }

    /** Collapse Header **/
    var contentHeader = document.querySelectorAll("div.collapse-header");
    for (var i = 0; i < contentHeader.length; i++) {
      if (contentHeader[i].classList.contains("in")) {
        //content[i].classList.replace("in", "collapse");
        contentHeader[i].classList.remove("in");
      }

    }


    document.getElementById("EstimateTotalPrice").innerHTML = "$" + total_amount.toFixed(2);


  }


  /* 
    This function for the checkbox
    Everytime user click/unclick checkbox this function are execute
  */
  function selectAddons() {


    /* 
      Everytime user click the checkbox
      this block will compute the total amount of ads-on
      the user's checked/unchecked
    */
    var total = 0; //variable for all the list of checkbox per engine series
    var input = document.querySelectorAll("input.disclamer-checkbox"); //get all the checkbox value by its "class-name"

    for (var i = 0; i < input.length; i++) {
      var inputSplit = input[i].value;
      if (input[i].checked) {
        console.log("checked")
        console.log(inputSplit);
        if (inputSplit.includes("$")) {
          var price = inputSplit.split('$');
          total += parseFloat(price[1]);
        }
      }
    }

    var inputSelect = document.querySelectorAll("select.disclamer-select"); //get all the checkbox value by its "class-name"
    for (var i = 0; i < inputSelect.length; i++) {

      var inputSplit = inputSelect[i].value;
      if (inputSelect[i].selected = true) {
        console.log("selected")
        console.log(inputSplit);
        if (inputSplit.includes("$")) {
          var price = inputSplit.split('$');
          total += parseFloat(price[1]);
        }
      }
    }




    /** for (var i = 0; i < inputSelect.length; i++) {
        var inputSplit = inputSelect[i].value;
        console.log("selected");
        console.log(inputSplit);

        if (inputSelect[i].selected = true) {

          var price = inputSplit.split('$');
          console.log(inputSplit);
          console.log(price);

          total += parseFloat(price[1]);

        }
      }

    }*/

    total += total_amount;

    // Display the total amount into "input hidden" and "h2"
    document.getElementById("EstimateTotalPrice").innerHTML = "$" + total.toFixed(2);
  }


/**Selects and Resets all check box in specific sections */
